{
	"Samsung": {
		"Galaxy S26 Ultra": [
			"SM-S948"
		],
		"Galaxy S26+": [
			"SM-S947"
		],
		"Galaxy S26": [
			"SM-S942"
		],
		"Galaxy S25 FE": [
			"SM-S731"
		],
		"Galaxy S25 Edge": [
			"SM-S937"
		],
		"Galaxy S25 Ultra": [
			"SM-S938"
		],
		"Galaxy S25+": [
			"SM-S936"
		],
		"Galaxy S25": [
			"SM-S931"
		],
		"Galaxy S24 FE": [
			" SM-S721"
		],
		"Galaxy S24 Ultra": [
			"SM-S928"
		],
		"Galaxy S24+": [
			"SM-S926"
		],
		"Galaxy S24": [
			"SM-S921"
		],
		"Galaxy S23 Ultra": [
			"SM-S918",
			"SCG20",
			"SC-52D"
		],
		"Galaxy S23+": [
			"SM-S916"
		],
		"Galaxy S23": [
			"SCG19",
			"SC-51D",
			"SM-S911C"
		],
		"Samsung Galaxy Z Fold 7": [
			"SM-F966"
		],
		"Samsung Galaxy Z Fold 6": [
			"SM-F956"
		],
		"Samsung Galaxy Z Fold 5": [
			"SM-F946"
		],
		"Samsung Galaxy Z Fold 4": [
			"SM-F936",
			"SCG16",
			"SC-55C"
		],
		"Samsung Galaxy Z Flip 7 FE": [
			"SM-F761"
		],
		"Samsung Galaxy Z Flip 7": [
			"SM-F766"
		],
		"Samsung Galaxy Z Flip 6": [
			"SM-F741"
		],
		"Samsung Galaxy Z Flip 5": [
			"SM-F731"
		],
		"Samsung Galaxy Z Flip 4": [
			"SM-F721",
			"SCG17",
			"SC-54C",
			"SM-F721C"
		],
		"Galaxy A56 5G": [
			"SM-A566"
		],
		"Galaxy A36 5G": [
			"SM-A366"
		],
		"Galaxy A55 5G": [
			"SM-A556"
		],
		"Galaxy A54 5G": [
			"SM-A546",
			"SCG21",
			"SC-53D",
			"SM-A546S"
		],
		"Galaxy A17 5G": [
			"SM-A176"
		]
	},
	"Pixel": {
		"Pixel 10a": [
			"Pixel 10a",
			"GE1GQ",
			"GV0BP",
			"G4H7L"
		],
		"Pixel 10 Pro Fold": [
			"Pixel 10 Pro Fold",
			"GU0NP",
			"GM66V"
		],
		"Pixel 10 Pro XL": [
			"Pixel 10 Pro XL",
			"G45RY",
			"GUL82",
			"GYPW4"
		],
		"Pixel 10 Pro": [
			"Pixel 10 Pro",
			"GEHN3",
			"G4QUR",
			"GN4F5"
		],
		"Pixel 10": [
			"Pixel 10",
			"GK2MP",
			"GLBW0",
			"GL066"
		],
		"Pixel 9a": [
			"Pixel 9a",
			"GXQ96",
			"GTF7P",
			"G3Y12"
		],
		"Pixel 9 Pro Fold": [
			"Pixel 9 Pro Fold",
			"GGH2X",
			"GC15S"
		],
		"Pixel 9 Pro XL": [
			"Pixel 9 Pro XL",
			"GGX8B",
			"GZC4K",
			"GQ57S"
		],
		"Pixel 9 Pro": [
			"Pixel 9 Pro",
			"GR83Y",
			"GEC77",
			"GWVK6"
		],
		"Pixel 9": [
			"Pixel 9",
			"G2YBB",
			"GUR25",
			"G1B60"
		],
		"Pixel 8a": [
			"Pixel 8a",
			"GKV4X",
			"G6GPR",
			"G8HHN",
			"G576D"
		],
		"Pixel 8 Pro": [
			"Pixel 8 Pro",
			"GC3VE",
			"G1MNW"
		],
		"Pixel 8": [
			"Pixel 8",
			"GKWS6",
			"G9BQD",
			"GA04851-US",
			"GZPFO",
			"GPJ41"
		]
	},
	"Motorola": {
		"Razr (2025)": [
			"Razr (2025)",
			"XT2553",
			"PB880025US",
			"PB770070US",
			"PB770019US",
			"PB2J0018US"
		],
		"Edge (2025)": [
			"Edge (2025)",
			"XT2519"
		]
	},
	"Sony": {
		"Sony Xperia 1 V": [
			"Sony Xperia 1V",
			"Sony Xperia 1 V",
			"XQDQ62",
			"XQ-DQ72",
			"XQ-DQ54",
			"XQ-DQ44",
			"XQ-DQ54",
			"XQ-DQ62",
			"SO-51D",
			"SOG10",
			"A301SO"
		]
	}
}